__turbopack_context__.v({
  "embla__button": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button",
  "embla__button__dark": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button__dark",
  "embla__button__isAccountPreview": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button__isAccountPreview",
  "embla__button__isListingDetailPreview": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button__isListingDetailPreview",
  "embla__button__isMapPreview": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button__isMapPreview",
  "embla__button__left": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button__left",
  "embla__button__right": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button__right",
  "embla__button__svg": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button__svg",
  "embla__button__svg__right": "listing-carousel-arrows-module-scss-module__-48IYW__embla__button__svg__right",
});
